export const DEFAULT_VOICE_ID = "OYTbf65OHHFELVut7v2H";
